<div class="push-notification-tab-content-create">
    <form
        (ngSubmit)="f.form.valid && processCreateData()"
        #f="ngForm"
        novalidate
    >
        <!-- -TITLE -->
        <div class="form-group">
            <mat-form-field>
                <input
                    matInput
                    placeholder="Title (Max. 25 Characters)"
                    maxlength="25"
                    [(ngModel)]="createNotoficationData.title"
                    name="title"
                    #title="ngModel"
                    required
                    (keypress)="keyPressAlpha($event)"
                >
                <mat-error *ngIf="f.submitted && title.invalid">Title is required</mat-error>
            </mat-form-field>
        </div>
        <!-- -DESCRIPTION -->
        <div class="form-group">
            <mat-form-field>
                <textarea
                    matInput
                    placeholder="Description (Max. 80 Characters)"
                    maxlength="80"
                    [(ngModel)]="createNotoficationData.description"
                    name="description"
                    #description="ngModel"
                    required
                ></textarea>
                <mat-error *ngIf="f.submitted && description.invalid">Description is required</mat-error>
            </mat-form-field>
        </div>
        <!-- -FILE UPLOAD -->
        <div class="form-group">
            <app-file-input *ngIf="!croppedImage"
                (fileChange)="onFileChange($event)"
                [(ngModel)]="createNotoficationData.fileName"
                name="fileName"
                placeholder="Upload Image"
                #fileName="ngModel"
            >
                <button
                    type="button"
                    mat-raised-button
                    color="primary"
                >
                    Choose
                </button>
            </app-file-input>

            <div *ngIf="croppedImage">
                <img [src]="croppedImage"  [alt]="file?.name" />
                <button
                type="button"
                mat-icon-button
                (click)="croppedImage=null"
              >
                <span class="material-icons">clear</span>
              </button>
            </div>
        </div>
        <!-- SELECT LINK -->


        <div class="form-group">
            <mat-form-field>
                <mat-select
                    disableOptionCentering
                    placeholder="Select Link"
                    [(ngModel)]="createNotoficationData.linkId"
                    name="link"
                    #link="ngModel"
                    required
                >
                    <mat-option
                        *ngFor="let item of linkList"
                        [value]="item.val"
                    >
                        {{ item.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="f.submitted && link.invalid">Please select link</mat-error>
        </div>
        <div class="push-notification-create-action">
            <button
                mat-raised-button
                color="primary"
                class="mat-button-large"
                type="submit"
                [disabled]="!f.valid"
            >
                Save
            </button>
        </div>
    </form>
</div>
